import React, { useRef, useState, useEffect } from 'react';
import { Collapse } from 'reactstrap';
import styles from './index.module.scss';

import { Skeleton, UiKit } from 'components';
import { ReactComponent as Arrow } from 'assets/img/icons/down-only.svg';

export default function ExpandableSection({
  title = '',
  badgeText = '',
  isError = false,
  isLoading = false,
  isDisabled = false,
  errorMsg = 'Unable to get the data. Please try again later.',
  children = null,
  onFirstTimeOpen = () => {}
}) {
  const [show, setShow] = useState(false);
  const hasSectionExpandedOnce = useRef(false);

  useEffect(() => {
    if (isDisabled) setShow(false);
  }, [isDisabled]);

  const toggleTimeline = () => {
    if (isLoading || isDisabled) return;
    setShow(currShow => {
      if (!hasSectionExpandedOnce.current) {
        hasSectionExpandedOnce.current = true;
        onFirstTimeOpen();
      }
      return !currShow;
    });
  };

  return (
    <div className={styles.container}>
      <div
        data-loading={isLoading}
        onClick={toggleTimeline}
        className={styles.head}
      >
        <div className={styles.title}>
          <h5 className={styles.label}>{title}</h5>
          {badgeText && <span className={styles.badge}>{badgeText}</span>}
        </div>
        {isLoading ? (
          <Skeleton width="26px" height="26px" className="mb-0" />
        ) : (
          <UiKit.Button
            size="sm"
            variant="ghost"
            disabled={isLoading}
            data-collapse={show ? 'open' : 'closed'}
            className="p-0"
          >
            <Arrow width="12" height="12" />
          </UiKit.Button>
        )}
      </div>
      <Collapse isOpen={show}>
        <div className={styles.content}>
          {isError ? <p className={styles.error}>{errorMsg}</p> : children}
        </div>
      </Collapse>
    </div>
  );
}
